import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxChecked = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0) scale(1.2632)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 19,
			rx: 5,
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12.6548 6.28052C12.8045 6.13803 13.0037 6.05925 13.2103 6.06081C13.417 6.06238 13.6149 6.14416 13.7624 6.2889C13.9099 6.43364 13.9954 6.63002 14.0009 6.8366C14.0064 7.04319 13.9314 7.24381 13.7917 7.39614L9.55235 12.698C9.47945 12.7765 9.39147 12.8395 9.29366 12.8833C9.19586 12.927 9.09023 12.9506 8.98311 12.9526C8.87599 12.9546 8.76957 12.9349 8.67021 12.8948C8.57085 12.8547 8.4806 12.795 8.40485 12.7193L5.59347 9.90789C5.51518 9.83494 5.45238 9.74696 5.40883 9.64922C5.36528 9.55147 5.34186 9.44595 5.33997 9.33895C5.33808 9.23195 5.35776 9.12567 5.39784 9.02645C5.43792 8.92722 5.49757 8.83709 5.57324 8.76142C5.64891 8.68575 5.73905 8.62609 5.83827 8.58601C5.9375 8.54594 6.04378 8.52625 6.15078 8.52814C6.25777 8.53003 6.36329 8.55345 6.46104 8.597C6.55879 8.64056 6.64677 8.70335 6.71972 8.78164L8.9446 11.0055L12.6347 6.30389C12.6413 6.29571 12.6484 6.28791 12.6559 6.28052H12.6548Z",
			fill: "white"
		})]
	})]
});
const ForwardRef = forwardRef(SvgCheckboxChecked);
export default ForwardRef;
